module.exports = __webpack_public_path__ + "img/toggle-03-right.01d58ee2.svg";